import Glide, { Controls, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
import ArrowDisabler from "./ArrowDisabler";
import Modal from "./Modal";

class Lightbox{
    constructor(wrapper){
        this.wrapper = document.querySelector(wrapper);
        if(this.wrapper){
            const _this = this;
            this.glide = this.initGlide();
            this.resizeDone = false;
            if(this.glide){
                this.onGlideSlide(this.glide);
                this.lightboxOnGlide();
            }

            this.photosGallery = this.wrapper.querySelectorAll(".gallery img");
            if (this.photosGallery) {
                this.photosGallery.forEach(function (photo){
                    if(_this.glide){
                        _this.initGallery(_this.glide, photo);
                    }
                });
            }
        }
    }

    initGlide(){
      const glideEl = this.wrapper.querySelector(".glide");
      var glide = null;
      if (glideEl) {
        glide = new Glide(glideEl, {
          perView: glideEl.dataset.perView ? glideEl.dataset.perView : 3,
          gap: glideEl.dataset.gap ? glideEl.dataset.gap : 10,
          type: 'slider',
          rewind: false,
          bound: true,
          breakpoints: {
            600: {
              perView: glideEl.dataset.mobilePerView ? glideEl.dataset.mobilePerView : 1.3
            },
            800: {
              perView: glideEl.dataset.tabletPerView ? glideEl.dataset.tabletPerView : 2.3
            },
            1000: {
              perView: glideEl.dataset.desktopPerView ? glideEl.dataset.desktopPerView : 3.3
            }
          }
        });

        glide.mount({ Controls, Breakpoints, Swipe, ArrowDisabler });

        return glide;
      }
    }

    onGlideSlide(glide){
      const _this = this;
      var photoNumber = this.wrapper.querySelector("#photoNumber");
      const currentContentActive = this.wrapper.querySelector(".content:not(.hidden)");
      glide.on("run.after", function () {
        if(!_this.resizeDone){ //Workaround for glide bug...
          window.dispatchEvent(new Event("resize"));
          _this.resizeDone = true;
        }

        let currentPhotoActive = _this.wrapper.querySelector(".gallery img.active");
        if (currentPhotoActive) {
          currentPhotoActive.classList.toggle("active");
        }

        // if (currentContentActive) {
          // currentContentActive.classList.toggle("hidden");
        // }

        let glideIndex = glide.index;
        let gallery = _this.wrapper.querySelectorAll(".gallery img");
        if(gallery.length) {
          gallery[glideIndex].classList.toggle("active");
        }

        if (photoNumber) {
          photoNumber.textContent = glideIndex + 1;
        }

        window.setTimeout(function () {
          const activeSlide = _this.wrapper.querySelector(".glide__slide--active");
          if (activeSlide) {
            let experienceID = activeSlide.dataset.experienceId;
            const activeCard = _this.wrapper.querySelector(".card-gallery:not(.hidden)");
            if (activeCard) {
              activeCard.classList.toggle("hidden");
            }

            const cardToActive = _this.wrapper.querySelector(".card-gallery[data-experience-id='" + experienceID + "']");
            if (cardToActive) {
              cardToActive.classList.toggle("hidden");
            }

            const contentToActive = _this.wrapper.querySelector(".content[data-experience-id='" + experienceID + "'].hidden");
            if (contentToActive && currentContentActive) {
              // console.log(contentToActive);
              // contentToActive.classList.toggle("hidden");
              currentContentActive.textContent = contentToActive.textContent;
            }
          }
        }, 100);
      });
    }

    initGallery(glide, photo){
      const _this = this;

      photo.addEventListener("click", function () {
          let glideIndex = photo.dataset.glideDir;
          glide.go("=" + glideIndex);

          let currentPhotoActive = _this.wrapper.querySelector(".gallery img.active");
          if (currentPhotoActive) {
              currentPhotoActive.classList.toggle("active");
          }
          photo.classList.toggle("active");
      });

      document.addEventListener("keydown", function(e){
        if(_this.wrapper.classList.contains("active")){
          if(e.keyCode === 37){
            glide.go("<");
          }
          else if(e.keyCode === 39){
            glide.go(">");
          }
        }
      });
    }

    lightboxOnGlide(){
      let start_time;
      function onMouseDown() {
          start_time = new Date();
      }

      function onMouseUp() {
          let now = new Date();
          let delay = now - start_time;
          if(delay < 100){
            Modal.toggleModal("#lightbox");
          }
      }

      const photos = document.querySelectorAll(".triggerLightbox");
      if(photos){
        photos.forEach(function(photo){
          photo.addEventListener("mousedown", onMouseDown);
          photo.addEventListener("mouseup", onMouseUp);
        });
      }
    }
}

export default Lightbox;
